import React, { useEffect, useState } from 'react'
import {
  StyleHamBurgerMenu,
  StyleHeaderWrapper,
  StyleMenuWrapper,
  StyleLink,
  StyleButtonWrapper,
  StyleButtonOutline,
  StyleButtonSolid,
  StyleLinkWrapper,
} from './style'
import { HamBurgerMenu } from '@assets/icons'
import { crossIcon } from '../svgs/svg'
import Logo from './logo.png'
import { StyleHeaderLogo } from '@commons/layouts/public/header/style'
import { useNavigate, useLocation } from 'react-router-dom'

const LinksArr = [
  { label: 'Company', navigateTo: '/' },
  { label: 'Services', navigateTo: '/service' },
  { label: 'About Us', navigateTo: '/about-us' },
  { label: 'Blogs', navigateTo: 'https://blogs.supachar.com', external: true },
  { label: 'Contact Us', navigateTo: '/contact-us' },
]

const PhoneMenu = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => setIsMenuOpen((prev) => !prev)

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMenuOpen])

  const handleLinkClick = (link) => {
    setIsMenuOpen(false)
    if (link.external) {
      window.open(link.navigateTo, '_blank')
    } else {
      navigate(link.navigateTo)
    }
  }

  return (
    <>
      <StyleHamBurgerMenu onClick={toggleMenu}>
        {!isMenuOpen && (
          <div dangerouslySetInnerHTML={{ __html: HamBurgerMenu }} />
        )}
      </StyleHamBurgerMenu>

      <StyleMenuWrapper isMenuOpen={isMenuOpen}>
        <StyleHeaderWrapper>
          <StyleHeaderLogo
            height="45"
            src={Logo}
            onClick={() => {
              setIsMenuOpen(false)
              navigate('/')
            }}
          />
          <StyleHamBurgerMenu onClick={toggleMenu}>
            {isMenuOpen && (
              <div dangerouslySetInnerHTML={{ __html: crossIcon }} />
            )}
          </StyleHamBurgerMenu>
        </StyleHeaderWrapper>

        <StyleLinkWrapper>
          {LinksArr.map((link, i) => {
            const isActive =
              !link.external && location.pathname === link.navigateTo
            return (
              <StyleLink
                key={i}
                onClick={() => handleLinkClick(link)}
                className={isActive ? 'active' : ''}
              >
                {link.label}
              </StyleLink>
            )
          })}
        </StyleLinkWrapper>

        <StyleButtonWrapper>
          <StyleButtonOutline
            onClick={() => {
              setIsMenuOpen(false)
              navigate('/role')
            }}
          >
            Register as Provider
          </StyleButtonOutline>
          <StyleButtonSolid
            onClick={() => {
              setIsMenuOpen(false)
              navigate('/login')
            }}
          >
            Login Now
          </StyleButtonSolid>
        </StyleButtonWrapper>
      </StyleMenuWrapper>
    </>
  )
}

export default PhoneMenu
